export const getMainPhone = (phones) => {
  for (let i in phones) {
    if (phones[i].Type == 3) {
      return phones[i];
    }
  }
};
